import { ThemedText } from "@/components/ThemedText";
import { FormLinkButton } from "@/components/ui/forms";
import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

interface AuthSwitchLinkProps {
  promptKey: string;
  actionKey: string;
  targetHref: string;
}

export function AuthSwitchLink({
  promptKey,
  actionKey,
  targetHref,
}: AuthSwitchLinkProps) {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <View className="flex-row items-center justify-center mt-6">
      <ThemedText className="text-sm text-gray-600">
        {t(promptKey)}{" "}
      </ThemedText>
      <FormLinkButton
        text={t(actionKey)}
        onPress={() => router.replace(targetHref as any)}
      />
    </View>
  );
}
